import { Base2Presenter } from "core/presenter";

export default class CompanyPresenter extends Base2Presenter {
  initialState() {
    return {
      currentUser: {}
    };
  }

  async onStart() {
    const currentUser = await this.mRuntime.get("currentUser");
    this.enqueue({ currentUser });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/company.presenter.js